import { ShieldCheck, BadgeCheck, FileCheck2 } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

const LOGOS = [
  { src: "/ria-member.webp", alt: "Restoration Industry Association Australasia — Member" },
  { src: "/iicrc-firm.png", alt: "IICRC Certified Firm" },
  { src: "/iaqaa.png", alt: "Indoor Air Quality Association Australia (IAQAA) — Member" },
];

const POINTS = [
  {
    icon: BadgeCheck,
    title: "Industry Members",
    desc: "Proud member of the Indoor Air Quality Association (Australian Chapter) and the Restoration Industry Association Australasia — upholding recognised industry standards.",
  },
  {
    icon: ShieldCheck,
    title: "IICRC Certified Firm",
    desc: "A certified firm with IICRC-certified technicians applying current standards on every job.",
  },
  {
    icon: FileCheck2,
    title: "Fully Insured",
    desc: "We hold Public Liability and Professional Indemnity insurance for the works we undertake.",
  },
];

export default function Accreditations() {
  return (
    <section
      id="accreditations"
      data-testid="accreditations-section"
      className="scroll-mt-20 border-t border-[#2a2a2a] bg-[#050505] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:items-end">
          <div className="md:col-span-8">
            <Reveal><Eyebrow>Accreditations & assurance</Eyebrow></Reveal>
            <Reveal i={1}>
              <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tighter text-[#f5f5f0] sm:text-5xl lg:text-6xl">
                Credentials that stand up to scrutiny.
              </h2>
            </Reveal>
          </div>
          <Reveal i={2} className="md:col-span-4">
            <p className="text-base leading-relaxed text-[#8a8a8a]">
              Final Sweep Solutions is a proud member of the Indoor Air Quality
              Association (Australian Chapter) and the Restoration Industry
              Association Australasia, and is an IICRC Certified Firm.
            </p>
          </Reveal>
        </div>

        {/* Logo tiles */}
        <div className="mt-14 grid grid-cols-1 gap-px border border-[#2a2a2a] bg-[#2a2a2a] sm:grid-cols-3">
          {LOGOS.map((l) => (
            <Reveal
              key={l.src}
              className="flex items-center justify-center bg-[#f5f5f0] p-10"
              data-testid={`accreditation-logo-${l.src.replace(/[/.]/g, "")}`}
            >
              <img
                src={l.src}
                alt={l.alt}
                className="max-h-24 w-auto object-contain"
                loading="lazy"
              />
            </Reveal>
          ))}
        </div>

        {/* Assurance points */}
        <div className="mt-px grid grid-cols-1 gap-px border-x border-b border-[#2a2a2a] bg-[#2a2a2a] md:grid-cols-3">
          {POINTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal
                key={p.title}
                i={i}
                className="group bg-[#050505] p-8 transition-colors duration-500 hover:bg-[#121212]"
              >
                <Icon className="h-8 w-8 text-[#c4a962]" strokeWidth={1.5} />
                <h3 className="mt-5 font-display text-xl font-medium tracking-tight text-[#f5f5f0]">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[#8a8a8a]">
                  {p.desc}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
